<template lang="pug">

svg.do-gra(
	viewBox="0 0 20 20"
	)
	defs
		//- Circles for % entry
		circle(:id="'local-result'+stat.name+this.$route.name" r="5" cx="10" cy="10" fill="black" stroke="black" stroke-width="11" :stroke-dasharray="localPercent" transform="rotate(-90) translate(-20)")
		circle(:id="'visitor-result'+stat.name+this.$route.name" r="5" cx="10" cy="10" fill="black" stroke="black" stroke-width="11" :stroke-dasharray="visitingPercent" transform="rotate(-90) translate(-20)")

		//- Donut Graph
		mask(:id="'local-init-mask'+stat.name+this.$route.name")
			circle(r="10" cx="10" cy="10" fill="white")
			use(:xlink:href="'#local-result'+stat.name+this.$route.name" x="0" y="0")

		circle(:id="'local-init'+stat.name+this.$route.name" r='10', cx='10', cy='10', :mask="'url(#local-init-mask'+stat.name+this.$route.name+')'")

		mask(:id="'visitor-init-mask'+stat.name+this.$route.name")
			circle(r="10" cx="10" cy="10" fill="white")
			use(:xlink:href="'#visitor-result'+stat.name+this.$route.name" x="0" y="0")

		circle(:id="'visitor-init'+stat.name+this.$route.name" r='10', cx='10', cy='10', :mask="'url(#visitor-init-mask'+stat.name+this.$route.name+')'" transform="scale(-1, 1) translate(-20, 0)")

		//- Elements
		mask(:id="'local-winner-mask'+stat.name+this.$route.name")
			use(:xlink:href="'#local-init'+stat.name+this.$route.name" x="0" y="0" fill="white")
			circle(r="8" cx="10" cy="10" fill="black")

		mask(:id="'local-loser-mask'+stat.name+this.$route.name")
			use(:xlink:href="'#local-init'+stat.name+this.$route.name" x="0" y="0" fill="white")
			circle(r="9" cx="10" cy="10" fill="black")

		mask(:id="'visitor-winner-mask'+stat.name+this.$route.name")
			use(:xlink:href="'#visitor-init'+stat.name+this.$route.name" x="0" y="0" fill="white")
			circle(r="8" cx="10" cy="10" fill="black")

		mask(:id="'visitor-loser-mask'+stat.name+this.$route.name")
			use(:xlink:href="'#visitor-init'+stat.name+this.$route.name" x="0" y="0" fill="white")
			circle(r="9" cx="10" cy="10" fill="black")

		//- Elements for use
		circle(:id="'local-winner'+stat.name+this.$route.name" r='10', cx='10', cy='10', :mask="'url(#local-winner-mask'+stat.name+this.$route.name+')'" fill="#4B4B4B")
		circle(:id="'local-loser'+stat.name+this.$route.name" r='10', cx='10', cy='10', :mask="'url(#local-loser-mask'+stat.name+this.$route.name+')'" fill="#4B4B4B")
		circle(:id="'visitor-winner'+stat.name+this.$route.name" r='10', cx='10', cy='10', :mask="'url(#visitor-winner-mask'+stat.name+this.$route.name+')'" fill="#808080")
		circle(:id="'visitor-loser'+stat.name+this.$route.name" r='10', cx='10', cy='10', :mask="'url(#visitor-loser-mask'+stat.name+this.$route.name+')'" fill="#808080")

	use(v-if="isVisitingWin" :xlink:href="isLocalWin ? '#local-winner'+stat.name+this.$route.name : '#local-loser'+stat.name+this.$route.name" x="0" y="0" )
	use(v-if="isVisitingWin" :xlink:href="isVisitingWin ? '#visitor-winner'+stat.name+this.$route.name : '#visitor-loser'+stat.name+this.$route.name" x="0" y="0")

	use(v-if="!isVisitingWin" :xlink:href="isVisitingWin ? '#visitor-winner'+stat.name+this.$route.name : '#visitor-loser'+stat.name+this.$route.name" x="0" y="0")
	use(v-if="!isVisitingWin" :xlink:href="isLocalWin ? '#local-winner'+stat.name+this.$route.name : '#local-loser'+stat.name+this.$route.name" x="0" y="0" )


	svg(viewBox="0 0 130 25")
		text(x="50%" y="-2" text-anchor="middle" dominant-baseline="hanging" fill=$black font-size="13px" font-weight="bold") {{stat.displayName ? $t(stat.displayName) : $t(stat.name)}}
		text(x="47%" y="17" text-anchor="end" dominant-baseline="hanging" fill="#4B4B4B" font-size="14px" font-weight="bold") {{parsedValue(stat.local_team[0].val)}}
		line(x1="50%" y1="18" x2="50%" y2="30" style="stroke:rgb(0,0,0);stroke-width:1")
		text(x="53%" y="17" dominant-baseline="hanging" fill="#808080" font-size="14px" font-weight="bold") {{parsedValue(stat.visiting_team[0].val)}}
</template>

<script>

export default {
	name: "Leaders",
	props: {
		stat: Object,
		decimals: {
			type: Number,
			default: 0
		}
	},
	computed: {
		isSafari() {
			return (this.$store.state.general.browser.indexOf('applewebkit/') > -1) && (this.$store.state.general.browser.indexOf('chrome/') == -1) && (this.$store.state.general.browser.indexOf('chromium/') == -1 && (this.$store.state.general.browser.indexOf('chrome/') == -1))
		},
		localCalc() {
			return (100 - this.calcPercent(this.$props.stat.local_team[0].val)) * 2 * 3.14 * 5 / 100
		},
		visitingCalc() {
			return (100 - this.calcPercent(this.$props.stat.visiting_team[0].val)) * 2 * 3.14 * 5 / 100
		},
		localPercent() {
			if (this.$props.stat.visiting_team[0].val == this.$props.stat.local_team[0].val) {
				return `15.25 31.4`
			} else if (!this.$props.stat.local_team[0].val) {
				return `31.4 31.4`
			} else {
				if ((this.$props.stat.visiting_team[0].val > this.$props.stat.local_team[0].val) && this.isSafari) {
					return `0 31.4`
				} else {
					return `${this.localCalc} 31.4`
				}
			}
		},
		visitingPercent() {
			if (this.$props.stat.local_team[0].val == this.$props.stat.visiting_team[0].val) {
				return `15.25 31.4`
			} else if (!this.$props.stat.visiting_team[0].val) {
				return `31.4 31.4`
			} else {
				if ((this.$props.stat.local_team[0].val > this.$props.stat.visiting_team[0].val) && this.isSafari) {
					return `0 31.4`
				} else {
					return `${this.visitingCalc} 31.4`
				}
			}
		},
		isLocalWin() {
			return (this.$props.stat.local_team[0].val > this.$props.stat.visiting_team[0].val)
		},
		isVisitingWin() {
			return (this.$props.stat.local_team[0].val < this.$props.stat.visiting_team[0].val)
		}
	},
	methods: {
		calcPercent(value) {
			return (value / (this.$props.stat.local_team[0].val + this.$props.stat.visiting_team[0].val) * 100)
		},
		addVisitor() {
			this.$props.stat.local_team[0].val = this.$props.stat.local_team[0].val + 1
		},
		parsedValue(value) {
			if (this.$props.decimals > 0) {
				return parseFloat(value).toFixed(this.$props.decimals)
			}
			if (Number.isInteger(value)) {
				return value;
			} else {
				return parseFloat(value).toFixed(1);
			}
		}

	}
}

</script>